import React, { useEffect, useState } from "react";
import { BsCalendar2Date } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { userProfile } from "../admin-data/data";
import { MdOutlineLogout, MdMenu, MdOutlineClose } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import {
  closeSidebar,
  openSidebar,
  toggleSidebar,
} from "../../redux/store/sidebarSlice";
import { logout } from "../../redux/store/userSlice";
import { toast } from "react-toastify";

const Topbar = () => {
  const [todayDate, setTodayDate] = useState("");
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const isOpen = useSelector((state) => state.sidebar.isOpen);
  const { user = null } = useSelector((state) => state.user?.admin) || {};
  const dispatch = useDispatch();
  useEffect(() => {
    const today = new Date();
    const day = today.getDate(); // 1-31
    const month = today.toLocaleString("default", { month: "short" }); // Jan, Feb, Mar
    setTodayDate(`${day} ${month}`);
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 900) {
        dispatch(closeSidebar()); // force hide if width < 900
      } else {
        dispatch(openSidebar()); // show sidebar on larger screens
      }
    };

    // Call once on mount
    handleResize();

    // Listen to resize
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(logout());
    toast.success("Admin Logout Successfully");
    navigate("/auth");
  };

  const handleProfileClick = (link) => {
    if (link === "/profile") {
      navigate("/dashboard/profile");
    } else {
      // For other links, you can add navigation logic later
      console.log("Navigate to:", link);
    }
    setIsActive(false);
  };
  return (
    <div className="px-4 sm:px-6 lg:px-10 py-4 bg-[#0b0b0f] text-white flex justify-between items-center border-b border-white/10">
      {/* LEFT SIDE */}
      <div className="flex items-center gap-4">
        <button
          onClick={() => dispatch(toggleSidebar())}
          className="p-2 rounded-lg hover:bg-white/10 transition"
        >
          <MdMenu size={26} />
        </button>

        <h1 className="text-xl sm:text-2xl font-semibold tracking-wide">
          Overview
        </h1>
      </div>

      {/* RIGHT SIDE */}
      <div className="flex items-center gap-3 sm:gap-5">
        {/* VIEW WEBSITE */}
        <button
          onClick={() => navigate("/")}
          className="hidden sm:flex items-center px-4 py-2 rounded-xl bg-white/5 hover:bg-white/10 text-sm font-medium transition"
        >
          View Website
        </button>

        {/* DATE */}
        <div className="hidden md:flex items-center gap-2 px-4 py-2 rounded-xl bg-white/5 text-sm text-gray-300">
          <BsCalendar2Date size={16} />
          {todayDate}
        </div>

        {/* PROFILE */}
        <div className="relative">
          <button
            onClick={() => setIsActive(!isActive)}
            className="w-10 h-10 rounded-full overflow-hidden border border-white/10 hover:scale-105 transition"
          >
            <img
              src="https://img.icons8.com/clouds/1200/user-male-circle.jpg"
              alt="profile"
              className="w-full h-full object-cover"
            />
          </button>

          {/* DROPDOWN */}
          {isActive && (
            <div className="absolute right-0 mt-3 w-80 bg-[#121218]/90 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl overflow-hidden">
              {/* USER INFO */}
              <div className="flex items-center gap-3 p-4">
                <img
                  src="https://img.icons8.com/clouds/1200/user-male-circle.jpg"
                  alt=""
                  className="w-12 h-12 rounded-full"
                />
                <div>
                  <p className="font-semibold text-white">{user?.name || "Admin"}</p>
                  <p className="text-xs text-gray-400">{user?.email || "admin@example.com"}</p>
                </div>
              </div>

              <div className="border-t border-white/10" />

              {/* MENU */}
              <div className="p-2 space-y-1">
                {userProfile.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => handleProfileClick(item.link)}
                    className="flex items-center gap-3 px-4 py-2 rounded-xl text-sm text-gray-300 hover:bg-white/5 hover:text-white cursor-pointer transition"
                  >
                    {item.icon}
                    {item.title}
                  </div>
                ))}

                {/* LOGOUT */}
                <div
                  onClick={handleLogout}
                  className="flex items-center gap-3 px-4 py-2 rounded-xl text-sm text-red-400 hover:bg-red-500/10 cursor-pointer transition"
                >
                  <MdOutlineLogout size={18} />
                  Logout
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
